module.exports = __webpack_public_path__ + "static/media/New-transfer-active.b149b19c.svg";